import {
  ChainID,
  ChainPath,
  isTestnetPremiumOnly,
} from '@ankr.com/chains-list';
import { Dispatch, SetStateAction } from 'react';

import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useGroupedEndpoints } from 'modules/endpoints/hooks/useGrouppedEndpoints';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { ChainTypeSelectorWithSubchains } from '../ChainTypeSelectorWithSubchains';
import { ProjectChain } from '../../types';
import { chainTypeSelectorWithSubchainsTranslation } from './translation';

interface ISubchainSelectorsProps {
  isLoading?: boolean;
  chain: ProjectChain;
  selectedChainPaths: ChainPath[];
  setSelectedChainPaths: Dispatch<SetStateAction<ChainPath[]>>;
  isLastChainInProject?: boolean;
  isLastPathSelected?: boolean;
}

export const SubchainSelectors = (props: ISubchainSelectorsProps) => {
  const { chain } = props;

  const isFlare = chain.id === ChainID.FLARE;
  const isTac = chain.id === ChainID.TAC;
  const isZkVerify = chain.id === ChainID.ZKVERIFY;
  const isPolkadot = chain.id === ChainID.POLKADOT;

  const endpoints = useGroupedEndpoints(
    chain,
    isFlare || isTac || isZkVerify || isPolkadot,
    isZkVerify,
  );

  const { isPremium } = useAccountStatus();

  const { keys, t } = useTranslation(chainTypeSelectorWithSubchainsTranslation);

  const {
    beaconsMainnet = [],
    beaconsTestnet = [],
    devnets = [],
    mainnets = [],
    opnodesMainnet = [],
    opnodesTestnet = [],
    signets = [],
    testnets = [],
  } = chain;

  return (
    <>
      <ChainTypeSelectorWithSubchains
        {...props}
        subchains={mainnets}
        endpoints={endpoints.mainnet}
        typeName={t(keys.mainnet)}
        hasPremiumColor={
          !isPremium && !chain.premiumOnly && chain.isMainnetPremiumOnly
        }
      />

      <ChainTypeSelectorWithSubchains
        {...props}
        subchains={testnets}
        endpoints={endpoints.testnet}
        typeName={t(keys.testnet)}
        shouldAvoidChainNameFormatting={!isZkVerify}
        hasPremiumColor={
          !isPremium && !chain.premiumOnly && isTestnetPremiumOnly(chain)
        }
      />

      <ChainTypeSelectorWithSubchains
        {...props}
        subchains={signets}
        endpoints={endpoints.signet}
        typeName={t(keys.signet)}
      />

      <ChainTypeSelectorWithSubchains
        {...props}
        subchains={devnets}
        endpoints={endpoints.devnet}
        typeName={t(keys.devnet)}
      />

      <ChainTypeSelectorWithSubchains
        {...props}
        subchains={beaconsMainnet}
        endpoints={endpoints.beaconsMainnet}
        typeName={t(keys.beaconsMainnet)}
        hasPremiumColor={!isPremium && !chain.premiumOnly}
      />

      <ChainTypeSelectorWithSubchains
        {...props}
        subchains={beaconsTestnet}
        endpoints={endpoints.beaconsTestnet}
        typeName={t(keys.beaconsTestnet)}
        hasPremiumColor={!isPremium && !chain.premiumOnly}
      />

      <ChainTypeSelectorWithSubchains
        {...props}
        subchains={opnodesMainnet}
        endpoints={endpoints.opnodesMainnet}
        typeName={t(keys.opnodesMainnet)}
        hasPremiumColor={!isPremium && !chain.premiumOnly}
      />

      <ChainTypeSelectorWithSubchains
        {...props}
        subchains={opnodesTestnet}
        endpoints={endpoints.opnodesTestnet}
        typeName={t(keys.opnodesTestnet)}
        hasPremiumColor={!isPremium && !chain.premiumOnly}
      />
    </>
  );
};
